/** Shared cell renderer styles (Driver Status, ETA, etc.) for reuse in other grids (e.g. Select Drivers) */
export const getDriverGridCellStyles = (theme) => ({
  "& .dispatch-message": {
    fontSize: "24px",
    paddingTop: "2px",
    cursor: "pointer",
  },
  "& .dispatch-new-message": {
    fill: `${theme.HeaderSelectedText}`,
  },
  "& .dispatch-new-message-number": {
    color: `${theme.HeaderSelectedText}`,
  },
  "& .dispaly-message": {
    display: "flex",
    justifyContent: "flex-end",
    width: 8
  },
  "& .driver-status-container": {
    display: "flex",
    justifyContent: "flex-end",
    alignItems: 'center'
  },
  "& .driver-status-icon-container": {
    width: "10%",
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
  },
  "& .driver-status-icon": {
    fill: `${theme.HeaderSelectedText}`,
  },
  "& .driver-status-stopType": {
    border: `1px solid ${theme.HeaderSelectedText}`,
    width: 14,
    height: 14,
    padding: 1,
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    borderRadius: 3,
    boxSizing: 'border-box',
    overflow: 'hidden',
    flexShrink: 0,
    "& svg": {
      maxWidth: '100%',
      maxHeight: '100%',
    }
  },
  "& .driver-status-stopType-delivery": {
    borderRadius: "50%",
  },
  '& .driver-status-label': {
    width: '90%',
    paddingLeft: '5px',
    overflow: 'hidden',
    textOverflow: 'ellipsis'
  },
  "& .dispatch-time": {
    display: 'flex',
    alignItems: 'center'
  },
  "& .dispatch-time-value-error": {
    color: theme.ErrorMessageColor
  },
  "& .dispatch-time-icon-container": {
    color: theme.ErrorMessageColor,
    paddingLeft: 5
  }
});

const styles = (theme) => ({
  dataGrid: {
    border: `1px solid ${theme.AppBGColor}`,
    "& .ag-theme-material .ag-body-horizontal-scroll": {
      borderWidth: "0px",
    },
    "&  .groupHeaderChildren": {
      borderLeft: `1px solid ${theme.AppBGColor} !important`,
      paddingRight: "12px !important",
    },
    "& .ag-theme-material": { // Fixed two issue: 1. Resizer issue(Not visible) 2. Filter Icon issue(Was left aligned), this issue only happening for no children header
      "& .ag-header-cell": {
        borderColor: theme.gridGroupHeaderBorderColor,
        "& .filterIcon": {
          right: 0,
          zIndex: 3,
          marginRight: 12
        },
        "&:not(.ag-header-group-cell)": {
          "& .ag-header-cell-resize": {
            width: 16,
            cursor: "col-resize",
            zIndex: 2,
          }
        }
      }
    },
    "& div[role='columnheader'][col-id='totalPickups']": {
      borderRight: `1px solid ${theme.AppBGColor} !important`,
    },
    "& div[col-id='5_0']": {
      borderRight: `1px solid ${theme.AppBGColor} !important`,
    },
    "& .groupHeaderParentDelivery": {
      borderLeft: `1px solid ${theme.groupHeaderParent} !important`,
      borderRight: `1px solid ${theme.groupHeaderParent} !important`,
      "& .ag-header-group-cell-label": {
        justifyContent: "center",
        flex: "auto"
      },
    },
    "& .groupHeaderParentPickup": {
      borderRight: `1px solid ${theme.groupHeaderParent} !important`,
      "& .ag-header-group-cell-label": {
        justifyContent: "center",
        flex: "auto"
      },
    },
    ...getDriverGridCellStyles(theme),
  },
});
export default styles;